

import { NgModule } from '@angular/core';

import { MwcConnectedOverlayDirective } from './mwc-connected-overlay';

@NgModule({
  declarations: [MwcConnectedOverlayDirective],
  exports: [MwcConnectedOverlayDirective]
})
export class MwcOverlayModule {}
